import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const legacySubmissionApiService = async () =>
  new JsonApiService("brsp_submissions", {
    baseUrl: `${visionURL}/admin_console/api/administration`,
    credentials: "include"
  });

export const useLegacySubmission = () => {
  return {
    getLegacySubmission: async legacySubmissionId => {
      const service = await legacySubmissionApiService();
      const response = await service
        .find(legacySubmissionId)
        .then(response => response.json());
      return dataFormatter.deserialize(response);
    }
  };
};
